import { initializeApp } from "firebase/app";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import Home from 'pages/Home/Home';
import Portfolio from 'pages/Portfolio/Portfolio';
import About from 'pages/About/About';
import Services from 'pages/Services/Services';
import Contact from 'pages/Contact/Contact';
import Post from "pages/Blog/Post"
import ScrollToTop from "components/ScrollToTop";

const firebaseConfig = {
    apiKey: "AIzaSyDW6E-UKNENQNNvdbLcAZ7CbFJrjMUvsSc",
    authDomain: "db-studio-53c6a.firebaseapp.com",
    projectId: "db-studio-53c6a",
    storageBucket: "db-studio-53c6a.appspot.com",
    messagingSenderId: "710936711179",
    appId: "1:710936711179:web:5612eb8b078438f851f70e"
};
const firebaseApp = initializeApp(firebaseConfig);

const App = () => (
  <Router>
    <ScrollToTop/>
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Post />} />
        </Routes>
      </div>
      <Footer />
    </div>
  </Router>
);

export default App;
